import React, { Component } from "react";
import { observer } from "mobx-react";
import { Button, Glyphicon } from "react-bootstrap";
import Core from "../../Core/";

export default observer(
	class CustomerListRow extends Component {
		onEditClicked() {
			const { customer } = this.props;
			const hash = `#customer-detail?id=${customer.Id}`;
			window.location.hash = hash;
		}

		onDeleteClicked() {
			var result = window.confirm("Delete record?");
			if (result) {
				const { customer } = this.props;
				customer.store.deleteById(customer.Id);
			}
		}

		onShowUsersClicked() {
			const { customer } = this.props;
			const hash = `#users-list?customerId=${customer.Id}`;
			window.location.hash = hash;
		}

		onShowLicensesClicked() {
			const { customer } = this.props;
			const hash = `#licenses-list?customerId=${customer.Id}`;
			window.location.hash = hash;
		}

		onShowLogsClicked() {
			const { customer } = this.props;
			const hash = `#logs?customerId=${customer.Id}`;
			window.location.hash = hash;
		}

		render() {
			const { customer } = this.props;

			return (
				<tr>
					<td className="col-sm-2">{customer.Name}</td>
					<td className="col-sm-1">{customer.Telephone}</td>
					<td className="col-sm-2">{customer.Email}</td>
					<td className="col-sm-2">{customer.InternalRemark}</td>
					<td className="col-sm-1">
						<Button type="button" bsStyle="info" onClick={this.onShowUsersClicked.bind(this)}>
							<Glyphicon glyph="user" /> <span>Users</span>
						</Button>
					</td>
					<td className="col-sm-1">
						<Button type="button" bsStyle="info" onClick={this.onShowLicensesClicked.bind(this)}>
							<Glyphicon glyph="credit-card" /> <span>Licenses</span>
						</Button>
					</td>
					<td className="col-sm-1">
						<Core.Components.Buttons.Logs onClick={this.onShowLogsClicked.bind(this)} />
					</td>
					<td className="col-sm-1">
						<Core.Components.Buttons.Edit onClick={this.onEditClicked.bind(this)} />
					</td>
					<td className="col-sm-1">
						<Core.Components.Buttons.Delete onClick={this.onDeleteClicked.bind(this)} />
					</td>
				</tr>
			);
		}
	}
);



// WEBPACK FOOTER //
// ./src/Components/CustomersList/CustomerListRow.js